import React, { useEffect } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/toast";
import CustomTextInput from "../UI/CustomTextInput";
import CustomSelect from "../UI/CustomSelect";
import CustomRadioButton from "../UI/CustomRadioButton";
let BASE_URL_FLORAHUB;

if (process.env.NODE_ENV === "production") {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
} else {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
}

const DeliveryForm = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  formDisable,
  setFormDisable,
  setFieldValue,
  profileData,
  isEdit,
}) => {
  const toast = useToast();
  const accessToken = localStorage.getItem("token");

  async function checkPincode() {
    try {
      const response = await axios.get(
        `${BASE_URL_FLORAHUB}/order/api/v1/delivery/checkPinStatus?pincode=${values["pincode"]}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        if (response.data.payload.status) {
          setFieldValue("city", response.data.payload.city);
          setFieldValue("state", response.data.payload.state);
          if (isEdit===false) {
            setFieldValue(
              "contactPersonName",
              profileData?.fullName ? profileData?.fullName : ""
            );
            setFieldValue(
              "contactNo",
              profileData?.mobileNumber ? profileData?.mobileNumber : ""
            );
          }else{
            setFieldValue("contactPersonName",values.contactPersonName);
            setFieldValue("contactNo",values["contactNo"]);
          }
          setFormDisable(false);
        }
        if (!response.data.payload.status) {
          setFormDisable(true);
          toast({
            title: "Invalid Pin Code",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast({
          title: error?.response?.data?.errors[0]?.appMessage || "Bad Request",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something Went Wrong",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      }
    }
  }

  useEffect(() => {
    if (values.pincode.length === 6) {
      checkPincode();
    }
  }, [values.pincode]);

  return (
    <>
      <div className="grid grid-cols-2">
        <CustomTextInput
          label="Pincode"
          textLimit={6}
          isRequired={true}
          type="text"
          name="pincode"
          value={values["pincode"] || ""}
          onChange={handleChange}
          error={errors["pincode"] && touched["pincode"] ? true : false}
          onBlur={handleBlur}
          helperText={errors["pincode"]}
        />
      </div>
      <div className="grid grid-cols-2">
        <div>
          <CustomTextInput
            label="Full Name"
            disabled={formDisable}
            textLimit={30}
            isRequired={true}
            type="text"
            name="contactPersonName"
            value={values.contactPersonName}
            onChange={handleChange}
            error={
              errors.contactPersonName && touched.contactPersonName
                ? true
                : false
            }
            onBlur={handleBlur}
            helperText={errors.contactPersonName}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>
        <div>
          <CustomTextInput
            label="Contact No"
            disabled={formDisable}
            textLimit={10}
            isRequired={true}
            type="number"
            name="contactNo"
            value={values["contactNo"] || ""}
            onChange={handleChange}
            error={errors["contactNo"] && touched["contactNo"] ? true : false}
            onBlur={handleBlur}
            helperText={errors["contactNo"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>

        <div>
          <CustomTextInput
            label="Address"
            disabled={formDisable}
            textLimit={80}
            isRequired={true}
            type="text"
            name="addressUnit"
            value={values["addressUnit"] || ""}
            onChange={handleChange}
            error={
              errors["addressUnit"] && touched["addressUnit"] ? true : false
            }
            onBlur={handleBlur}
            helperText={errors["addressUnit"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>

        <div>
          <CustomTextInput
            label="Locality"
            disabled={formDisable}
            textLimit={30}
            type="text"
            name="locality"
            value={values["locality"] || ""}
            onChange={handleChange}
            error={errors["locality"] && touched["locality"] ? true : false}
            onBlur={handleBlur}
            helperText={errors["locality"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>
        <div>
          <CustomTextInput
            label="Landmark"
            disabled={formDisable}
            textLimit={30}
            type="text"
            name="landmark"
            value={values["landmark"] || ""}
            onChange={handleChange}
            error={errors["landmark"] && touched["landmark"] ? true : false}
            onBlur={handleBlur}
            helperText={errors["landmark"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>
        <div>
          <CustomTextInput
            label="City"
            disabled={true}
            textLimit={30}
            isRequired={true}
            type="text"
            name="city"
            value={values["city"] || ""}
            onChange={handleChange}
            error={errors["city"] && touched["city"] ? true : false}
            onBlur={handleBlur}
            helperText={errors["city"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>
        <div>
          <CustomSelect
            id="addressType"
            isRequired
            disabled={formDisable}
            label="Address Type"
            name="addressType"
            value={values["addressType"] || ""}
            onChange={handleChange}
            error={
              errors["addressType"] && touched["addressType"] ? true : false
            }
            onBlur={handleBlur}
            options={[
              { value: "Select", label: "Select" },
              { value: "HOME", label: "Home" },
              { value: "OFFICE", label: "Office" },
              { value: "OTHERS", label: "Others" },
            ]}
            helperText={errors["addressType"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>

        <div>
          <CustomTextInput
            label="State"
            disabled={true}
            isRequired={true}
            type="text"
            name="state"
            value={values["state"] || ""}
            onChange={handleChange}
            error={errors["state"] && touched["state"] ? true : false}
            onBlur={handleBlur}
            helperText={errors["state"]}
            otherClass={`${formDisable ? "cursor-not-allowed" : ""}`}
          />
        </div>

        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mt-2">
            Set As Default
          </label>
          <div className="flex gap-3 mt-1">
            <CustomRadioButton
              label="True"
              disabled={formDisable}
              name="default"
              value="true"
              onChange={handleChange}
              isChecked={false}
            />
            <CustomRadioButton
              label="False"
              disabled={formDisable}
              name="default"
              value="false"
              onChange={handleChange}
              isChecked={true}
            />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default DeliveryForm;
